<template>
  <a-modal :title="title" :visible="showTubeView" :width="800" destroyOnClose @ok="handleOk" @cancel="closeTubeView">
    <a-modal
      title="地图"
      style="top: 20px"
      :width="800"
      v-model="mapVisible"
      @ok="mapVisible = false"
      @cancel="mapVisible = false"
    >
      <lonlat-map ref="lonlatMaps" @handleMapOk="handleMapOk"></lonlat-map>
    </a-modal>
    <!-- style="position: absolute; left: 18rem; z-index: 999; top: 3rem" -->
    <template slot="footer">
      <a-button @click="closeTubeView">取消</a-button>
      <a-button :disabled="isUpdate" type="primary" @click="handleOk">确定</a-button>
    </template>
    <a-form-model
      class="log-form"
      :model="addOrUpdateForm"
      ref="addOrUpdateForm"
      :rules="rules"
      :label-col="{ span: 7 }"
      :wrapper-col="{ span: 14 }"
    >
      <a-row class="form-row" type="flex" justify="center" :gutter="4">
        <a-col :md="12" :sm="24">
          <a-form-model-item label="设备名称" prop="deviceName">
            <a-input :disabled="isUpdate" placeholder="请输入" v-model="addOrUpdateForm.deviceName" />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="设备编码" prop="deviceNo">
            <a-input :disabled="isUpdate" placeholder="请输入" v-model="addOrUpdateForm.deviceNo" />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="负责人" prop="principal">
            <a-select
              show-search
              option-filter-prop="children"
              :filter-option="filterOption"
              v-model="addOrUpdateForm.principal"
              @change="handleChange"
              :disabled="isUpdate"
              placeholder="请选择"
            >
              <a-select-option v-for="item in userlist" :key="item.id">{{ item.realName }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <!-- <a-form-model-item label="任务名称" prop="matterContent">
            <a-input :disabled="isUpdate" placeholder="请输入" v-model="addOrUpdateForm.matterContent" />
          </a-form-model-item> -->
        </a-col>

        <a-col :md="12" :sm="24">
          <a-form-model-item label="片区">
            <a-tree-select
              :tree-data="zoneTreeData"
              v-model="addOrUpdateForm.zone"
              :replace-fields="{ title: 'zoneName', key: 'id', value: 'id', selectable: 'selectable' }"
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
              :disabled="isUpdate"
              placeholder="请选择片区"
              allow-clear
              tree-default-expand-all
            ></a-tree-select>
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="开始日期" prop="nextMaintenanceDat">
            <a-date-picker
              style="width: 218px"
              v-model="addOrUpdateForm.nextMaintenanceDat"
              format="YYYY-MM-DD"
              placeholder="开始日期"
              :disabled-date="disabledDate"
              :disabled-time="disabledDateTime"
              @change="onChanget"
            />
          </a-form-model-item>
        </a-col>
        <!-- <a-col :md="12" :sm="24">
          <a-form-model-item label="预计处理时长" prop="lastInspectionDate">
            <a-input
              v-model="addOrUpdateForm.lastInspectionDate"
              placeholder="预计处理时长"
              onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
              onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            />
          </a-form-model-item>
        </a-col>
        <a-col a-col :md="12" :sm="24">
          <a-form-model-item label="下次养护日期" prop="nextInspectionDate">
            <a-date-picker
              v-model="addOrUpdateForm.nextInspectionDate"
              style="width: 218px"
              :show-time="{ format: 'YYYY-MM-DD' }"
              format="YYYY-MM-DD"
              placeholder="下次养护日期"
              @change="onChanget"
            />
          </a-form-model-item>
        </a-col> -->
        <a-col :md="12" :sm="12">
          <a-form-model-item label="养护周期" prop="maintenanceFrequency">
            <a-select :disabled="isUpdate" placeholder="请选择养护周期" v-model="addOrUpdateForm.maintenanceFrequency">
              <a-select-option key="日">日</a-select-option>
              <a-select-option key="周">周</a-select-option>
              <a-select-option key="月">月</a-select-option>
              <a-select-option key="年">年</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>

        <a-col :md="12" :sm="24">
          <a-form-model-item label="计划处理时长" prop="planTime">
            <a-input v-model.number="addOrUpdateForm.planTime" placeholder="计划处理时长" />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24"> </a-col>
        <a-col :md="12" :sm="24"></a-col>
        <a-col :md="24" :sm="24">
          <a-form-model-item
            label="协办人"
            :label-col="{ span: 3 }"
            :wrapper-col="{ span: 20 }"
            props="maintenanceStaffs"
          >
            <a-button :disabled="isUpdate" @click="addSponsor" style="margin-right: 20px">添加</a-button>
            <a-tag v-for="item in maintenanceStaffsList" :key="item.key" closable @close="delSponsor(item.key)">{{
              item.title
            }}</a-tag>
          </a-form-model-item>
        </a-col>

        <a-col :md="12" :sm="12"></a-col>
        <!--        <a-col :md="12" :sm="24">-->
        <!--          <a-form-model-item label="应养护次数" prop="shouldMaintenanceCount">-->
        <!--            <a-input :disabled="isUpdate" placeholder="请输入" v-model="addOrUpdateForm.shouldMaintenanceCount" />-->
        <!--          </a-form-model-item>-->
        <!--        </a-col>-->
        <!-- <a-col :md="12" :sm="24"></a-col> -->
        <a-col :md="24" :sm="24">
          <a-form-model-item label="位置" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }" prop="place">
            <a-button type="primary" @click="addAddress">位置</a-button>
            <a-input :disabled="isUpdate" placeholder="请输入" v-model="addOrUpdateForm.place" />
          </a-form-model-item>
        </a-col>
        <a-col :md="24" :sm="24">
          <a-form-model-item
            label="设备位置"
            :label-col="{ span: 3 }"
            :wrapper-col="{ span: 20 }"
            prop="deviceLocation"
          >
            <a-textarea :disabled="isUpdate" placeholder="请输入" v-model="addOrUpdateForm.deviceLocation" :rows="2" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <addModal ref="addModal" @addPepople="addPepople"></addModal>
  </a-modal>
</template>
<script>
import dayjs from 'dayjs'
import moment from 'moment'
import addModal from './AddModal'
import LonlatMap from '../../../maintenance/EventManagement/modules/lonlatMap.vue'
export default {
  components: {
    addModal,
    LonlatMap,
    dayjs,
  },
  props: {},
  data() {
    return {
      dayjs,
      mapVisible: false,
      queryOneUrl: '/pipe-network/device_maintenances',
      addOrUpdateUrl: '/pipe-network/device_maintenances',
      showTubeView: false,
      id: '',
      addOrUpdateForm: {
        deviceLocation: '',
        place: '',
        deviceName: '', //1
        matterContent: '',
        deviceNo: '', //2
        maintenanceStaffs: [],
        principal: '',
        zone: '', //4
        nextMaintenanceDate: '', //6
        nextMaintenanceDat:'',
        shouldMaintenanceCount: '', //8
        address: '',
        nextInspectionDate: '',
        planTime: '',
      },
      zoneTreeData: [], // 分区数据选项
      eventTypeList: [],
      maintenanceStaffsList: [],
      userlist: [],
      currentId: '',
      isUpdate: false,
      title: '新增',
      isUpdate: false,
    }
  },
  computed: {
    rules() {
      return {
        deviceName: [{ required: true, message: '设备名称', trigger: 'change' }],
        matterContent: [{ required: true, message: '任务名称', trigger: 'change' }],
        deviceNo: [{ required: true, message: '请输入设备编码', trigger: 'change' }],
        zone: [{ required: true, message: '请选择片区', trigger: 'change' }],
        principal: [{ required: true, message: '请选择负责人', trigger: 'change' }],
        maintenanceFrequency: [{ required: true, message: '请选择养护周期', trigger: 'change' }],
        nextMaintenanceDat: [{ required: true, message: '请选择开始日期', trigger: 'change' }],
        place: [{ required: true, message: '请选择位置', trigger: 'change' }],
        deviceLocation: [{ required: true, message: '请输入地址', trigger: 'change' }],
        planTime: [
          { required: true, message: '请输入计划处理时长', trigger: 'change' },
          { pattern: /^(?:[1-9]\d?|[1234]\d{2}|500)$/, message: '请输入正整数', trigger: 'change' },
        ],
      }
    },
  },
  created() {
    this.getZoneData()
    this.getUserList()
  },
  methods: {
    disabledDate(current) {
      return current && current < dayjs().endOf('day')
    },
    disabledDateTime() {},
    onChanget(value, dateString) {
      //   console.log(value,dateString);
      this.addOrUpdateForm.nextMaintenanceDate = dateString + ' 00:00:00'
       this.addOrUpdateForm.nextMaintenanceDat = dateString
    },
    addAddress() {
      this.mapVisible = true
      if (this.addOrUpdateForm.place) {
        var pointData = this.addOrUpdateForm.place.split(',')
        var newPointData = pointData.map((item) => {
          return (item = parseFloat(item))
        })
        console.log(newPointData, this.$refs) // [113.678351, 25.538859]
        this.$nextTick(() => {
          this.$refs.lonlatMaps.changepoint(newPointData)
        })
      } else {
        this.$nextTick(() => {
          this.$refs.lonlatMaps.changepoint([0, 0])
        })
      }
    },
    handleMapOk(data) {
      this.addOrUpdateForm.deviceLocation = data.address
      this.addOrUpdateForm.place = data.point
      console.log(this.addOrUpdateForm.address)
    },
    moment,
    detail(id) {
      this.showTubeView = true
      this.currentId = id
      this.addOrUpdateForm = {
        deviceName: '', //1
        deviceNo: '', //2
        maintenanceStaffs: [],
        principal: '',
        zone: '', //4
        matterContent: '',
        maintenanceFrequency: '', //6
        shouldMaintenanceCount: '', //8
        planTime: '',
        nextMaintenanceDate: '',
        nextMaintenanceDat:'',
        deviceLocation: '',
        place: '',
      }
      this.$nextTick(() => {
        this.$refs.addOrUpdateForm.resetFields()
        if (id) {
          this.isUpdate = true
          this.$http
            .get(`${this.queryOneUrl}/${this.currentId}`)
            .then(({ data }) => {
              
              console.log(this._updateForm(this.addOrUpdateForm, data))
              this.addOrUpdateForm = { ...this._updateForm(this.addOrUpdateForm, data) }
              this.getPeopleList()
            })
            .catch(() => {})
        }
      })
    },
    handleChange(value) {
      this.addOrUpdateForm.principal = value
    },
    showLineLayer(record) {
      this.geoJson = record.geoJson
      this.mapVisible = true
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    getUserList() {
      this.$http.get('/manager/users/list').then(({ data }) => {
        
        this.userlist = data
      })
    },
    delSponsor(key) {
      let i = this.maintenanceStaffsList.findIndex((item) => {
        return item.key == key
      })
      this.maintenanceStaffsList.splice(i, 1)
      let j = this.addOrUpdateForm.maintenanceStaffs.indexOf(key)
      this.addOrUpdateForm.maintenanceStaffs.splice(j, 1)
    },
    addPepople(list) {
      this.maintenanceStaffsList = list
      this.addOrUpdateForm.maintenanceStaffs = []
      list.map((item) => {
        this.addOrUpdateForm.maintenanceStaffs.push(item.key)
      })
    },
    addSponsor() {
      this.$refs.addModal.edit(this.addOrUpdateForm.maintenanceStaffs)
    },
    handleOk(e) {
      e.preventDefault()
      this.$refs.addOrUpdateForm.validate((valid) => {
        if (valid) {
          this.$http[!this.currentId ? 'post' : 'put'](this.addOrUpdateUrl, {
            id: this.currentId,
            sysType: '巡检',
            ...this.addOrUpdateForm,
          })
            .then((res) => {
              if (res.code === 0) {
                this.closeTubeView()
                this.$emit('handleOk')
                return this.$message.success(res.message)
              }
            })
            .catch(() => {})
        }
      })
    },
    getZoneData() {
      this.$http.get('zone-metering/zone-metering').then(({ data }) => {
        this.zoneTreeData = data
      })
    },
    _updateForm(real, data) {
      let keys = Object.keys(real)
      let dataKeys = Object.keys(data)
      let newObject = {}
      keys.map((key) => {
        if (dataKeys.includes(key)) {
          newObject[key] = data[key]
        } else {
          newObject[key] = real[key]
        }
      })
      return newObject
    },
    edit(id) {
      this.showTubeView = true
      this.currentId = id
      this.addOrUpdateForm = {
        deviceName: '', //1
        deviceNo: '', //2
        maintenanceStaffs: [],
        principal: '',
        matterContent: '',
        zone: '', //4
        maintenanceFrequency: '', //6
        shouldMaintenanceCount: '', //8
        planTime: '',
        nextMaintenanceDate: '',
        nextMaintenanceDat:'',
        deviceLocation: '',
        place: '',
      }
      this.title = '新增'
      this.$nextTick(() => {
        this.$refs.addOrUpdateForm.resetFields()
        if (id) {
          this.title = '编辑'
          this.isUpdate = false
          this.$http
            .get(`${this.queryOneUrl}/${this.currentId}`)
            .then(({ data }) => {
              
              console.log(this._updateForm(this.addOrUpdateForm, data))
              this.addOrUpdateForm = { ...this._updateForm(this.addOrUpdateForm, data) }
              this.getPeopleList()
            })
            .catch(() => {})
        }
      })
    },
    getPeopleList() {
      this.$http.get('/manager/users/list').then(({ data }) => {
        
        let list = []
        data.map((item) => {
          list.push({
            title: item.realName,
            key: item.id,
          })
        })

        if (this.addOrUpdateForm.maintenanceStaffs.length) {
          this.maintenanceStaffsList = []
          this.addOrUpdateForm.maintenanceStaffs.map((item) => {
            this.maintenanceStaffsList.push(
              list.find((listItem) => {
                return listItem.key == item
              })
            )
          })
          console.log(this.maintenanceStaffsList, '1234')
        }
      })
    },
    closeTubeView() {
      this.showTubeView = false
      this.$refs.addOrUpdateForm.resetFields()
      console.log(this.addOrUpdateForm)
      this.maintenanceStaffsList = []
      this.$emit('handleOk')
    },
  },
}
</script>

<style lang="less" scoped>
</style>
